import { inject, Injectable } from '@angular/core';
import '@models';
import { NativeBridgeService } from '@native-bridge';
import { BaseEvent } from '../models/base-event.model';
import { eventRecognition, identifyAndMapEvent } from '../utils/event-mapper.utils';
import { analyticsOverrideUrls } from '../utils/merchant-query-param.util';

export interface TrackingProvider {
  trackEvent(e: BaseEvent | any): void;
}

@Injectable({
  providedIn: 'root',
})
export class EventTrackingService implements TrackingProvider {
  nativeBridgeService = inject(NativeBridgeService);

  trackEvent(event: BaseEvent | any) {
    if (event._ignore) {
      return;
    }
    this.buildEventPayload(event);
    this.recordEvent(event);
  }

  private recordEvent(event: BaseEvent): void {
    if (eventRecognition.pageLoadAction(event)) {
      analyticsOverrideUrls(event);
      console.log(
        'before RPT_RecordPageLoadEvent, analyticsUrlOverride, PageUrl, PageReferrer: ',
        window.analyticsUrlOverride,
        window.CHASE.analytics.config.PageUrl,
        window.CHASE.analytics.config.PageReferrer,
      );
      window.RPT_RecordPageLoadEvent();
    } else {
      window.RPT_RecordEvent();
    }
  }

  private buildEventPayload(event: any) {
    const RPT_AddVariables = (window as any).RPT_AddVariables;

    const mappedEventData = this.populateIsHybridAppProp(identifyAndMapEvent(event));
    Object.entries(mappedEventData).forEach(([adobeSpecificKeyFromChase, value]) => {
      RPT_AddVariables(adobeSpecificKeyFromChase, value);
    });
  }

  // to identify event as one from hybrid app
  private populateIsHybridAppProp(event: Record<string, any>): Record<string, any> {
    return {
      ...event,
      ...(this.nativeBridgeService.isHybridApp ? { hybridbundle: 'hybrid' } : {}),
    };
  }
}
